import _, { isEmpty } from 'lodash';
import './infoarea.css';
import React, { MutableRefObject, useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Portal } from 'react-portal';
import { useDropzone } from 'react-dropzone';

import ApplicationContext from '../../ApplicationContext';
import config from '../../config';
import SmartTable from '../SmartTable';
import { faUpload, faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextAlignLeftRenderer, TextRenderer, DateTimeRenderer, DateTimeIncludeSecRenderer } from '../SmartTableRenderers';

import BottomDrawer from '../../ui/BottomDrawer';
import DarkInverseButton from '../../ui/DarkInverseButton';
import FilterableSelect2 from '../../ui/FilterableSelect2';
import Label from '../../ui/Label';
import MultilineTextBox from '../../ui/MultilineTextBox';
import SecondaryButton from '../../ui/SecondaryButton';
import TextBox from '../../ui/TextBox';
import useTableRowSelection from '../../ui/tables/useTableRowSelection';

import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../hooks/useGlobalYesNoDialog';
import useSystemSettings from '../../hooks/useSystemSettings';
import { useTypedFastStorage } from '../../hooks/useFastStorage';

import { Search } from '../../filtering';
import { Memo } from '../../framework.core/Memo';
import { getTbNameByJobName, JobNames } from '../../framework.core/JobNames';
import { SQLField, SQLInfo, SQLType } from '../../framework.core/data/SQLInfo';
import { CodeMemoTitleListItem } from '../../fms.data/models/CodeMemoTitleListItem';
import { MemoPanelItem } from '../../fms.data/models/MemoPanelItem';
import { checkPropDirty, getSQLInfoList } from '../../fms.core/data/TrackingModule';
import { TrackableEntity } from '../../fms.core/data/ChangeTrackable';
import { ApiResult, InsertResultsWithData } from '../../framework.core/data/ApiResult';
import postal from 'postal';
import { infoAreaMemoTable, infoAreaLogHistoryTable, ApplicableTableSettings } from '../../tableSettings';
import excelImg from '../../img/memo_doc_excel.svg';
import pdfImg from '../../img/memo_doc_pdf.svg';
import pptImg from '../../img/memo_doc_ppt.svg';
import textImg from '../../img/memo_doc_text.svg';
import wordImg from '../../img/memo_doc_word.svg';
import msgImg from '../../img/memo_doc_msg.png';
import pngImg from '../../img/memo_doc_png.svg';
import constants from '../../constants';
import { MemoArgs } from '../../fms.report/args';
import useReportViewer from '../../hooks/useReportViewer';
import { appendLine, findSecurityTask } from '../../util';
import IfmsModal from '../../ui/IfmsModal';
import { FmsSecTask } from '../../fms.core/constants';
import { FmsSecCntr } from '../../fms.core/constants/FmsSecCntr';
import { FormType } from '../../fms.enum';
import memoUpDownIcon from '../../img/memo-up-down.svg';
import {MSGReader} from '../../msg.reader/msg.reader';
import { DocumentType } from '../../framework.core/DocumentType';
import EmailIcon from '../../img/loghistory/Email.png';
import FaxIcon from '../../img/loghistory/Fax.png';
import OutLookIcon from '../../img/loghistory/Outlook.png';
import PrintIcon from '../../img/loghistory/Print.png';
import SharedIcon from '../../img/loghistory/Shared.png';
import SharedPDFICon from '../../img/loghistory/Shared_PDF.png';
import UnSharedIcon from '../../img/loghistory/Unshared.png';
import UploadIcon from '../../img/loghistory/Upload.png';
import CheckBox from '../../ui/CheckBox';
import GrayButtonTabs from "../../ui/GrayButtonTabs";
import PrimaryButtonTabs from "../../ui/PrimaryButtonTabs";
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import LeftRightSplit from '../../ui/LeftRightSplit';
import RadioButton from '../../ui/RadioButton';
import UsersDropDown from '../UsersDropDown';
import DateTime from '../../ui/DateTime';
import { compareIso, now } from '../../dateUtils';
import DeepBlueButtonTabs from '../../ui/DeepBlueButtonTabs';
import { useHistory } from 'react-router';
import useSuntekSettings from '../../hooks/useSuntekSettings';
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*
const ModalContentStyle:React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10000,
  border: 'none',
  padding: '0px'

};
const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999997   //999999 -> 999998   <-- No show Subject List Value / 999998 -> 999997 <-- No show "Please input the Memo Subject" message
};
*/

const MemoDropzoneContainer = styled.div`
  border: 1px solid #e5e5e5;
  height: 130px;
  background-color: #f8fafb;
  overflow-y: auto;

  h3 {
    margin-top: 15px;
    color: #767373;
    text-align: center;
    font-size: 22px;
  }
  h4 {
    color: #767373;
    text-align: center;
    font-size: 18px;
  }

  .upload-icon {
    color: #e5e5e5;
    text-align: center;
    font-size: 36px;
  }
`;

class AttachFile {
  logId: number;
  logFileId: number;
  file: File;

  constructor(init?:Partial<AttachFile>) {
    // super();
    this.logId = 0;
    this.logFileId = 0;
    this.file = new File([],"");

    Object.assign(this, init);
  };
}
const channel = postal.channel('ajax');

function getFileIcon(filename: string)
{
  if (filename) {
    if (filename.indexOf('.pdf') >= 0) return pdfImg
    if (filename.indexOf('.xls') >= 0) return excelImg
    if (filename.indexOf('.xlsx') >= 0) return excelImg
    if (filename.indexOf('.doc') >= 0) return wordImg
    if (filename.indexOf('.docx') >= 0) return wordImg
    if (filename.indexOf('.ppt') >= 0) return pptImg
    if (filename.indexOf('.pptx') >= 0) return pptImg
    if (filename.indexOf('.msg') >= 0) return msgImg
    if (filename.indexOf('.png') >= 0) return pngImg
  }
  return textImg
}


function getOpNameByJobName(jobName: string) {
    switch(jobName) {
        case JobNames.WHRcv:                    return 'Receiving';
        case JobNames.WHShip:                   return 'Shipping';

        case JobNames.Invoice:                 return 'Invoice';            
        case JobNames.GInvo:                   return 'G.Invoice'; 
        case JobNames.WHStorageInv:            return 'Storage Invoice'; 

        case JobNames.CrDb:                    return 'CrDb';

        case JobNames.Bill:                    return 'Bill';          
        case JobNames.GBill:                   return 'G. Bill';

        case JobNames.BillPayment:             return 'Bill Pay';
        case JobNames.CustPayment:             return 'Customer Pay';

        case JobNames.BTOrder:                  return 'Manifest';
        case JobNames.BTLoadPlan:               return 'Load';
        case JobNames.BTDo:                     return 'Local D/O';

        case JobNames.Payroll2:                 return 'Payroll';
        case JobNames.Company:                  return 'Customer';
        
        default: return '';
    }
}

async function openLogFile(logFileId: number, logFileName: string, userToken: string) {
  if (logFileId <= 0 || !logFileName) return;

  try {
    const response = await fetch(`${config.serverUrl}memo/openLogFile?logFileId=${logFileId}&logFileName=${logFileName}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });

    if (response.ok) {
      const contentType = response.headers.get('content-type');

       //pdf
      if (contentType && contentType.toLowerCase().includes('application/pdf')) {
        const pdfBlob = await response.blob();
        const newWindow = window.open('', '_blank');

        if (newWindow) {
          const pdfUrl = URL.createObjectURL(pdfBlob);

          const iframe = document.createElement('iframe');
          iframe.src = pdfUrl;
          iframe.width = '100%';
          iframe.height = '100%';

          newWindow.document.body.style.margin = '0';
          newWindow.document.body.style.overflow = 'hidden';
          newWindow.document.title = logFileName;
          newWindow.document.body.appendChild(iframe);
        } else {
          console.error('error');
        }
      } else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = logFileName;
        a.click();
      }
    } else {
      console.error('error', response.status);
    }
  } catch (error) {
    console.error('error', error);
  }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function renderTitleButton(label: React.ReactNode | string | null | undefined, selected: boolean, onClick: VoidFunction, useDarkMode: boolean) {
  const Button = !selected ? GrayButtonTabs : !useDarkMode ? PrimaryButtonTabs : DeepBlueButtonTabs;

  return <Button size='regular' onClick={onClick}>{label}</Button>
}

function MemoDetails({ memo, setMemo, memoTitle, files, setFiles }: {
  memo: Memo,
  setMemo: (change: Partial<Memo>) => void,
  memoTitle: any,
  files: Array<any>,
  setFiles: (change: Partial<Array<any>>) => void,
}) {
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [tabIndex, setTabIndex, //removeTabIndexFromStorage
  ] = useTypedFastStorage<number>('0');  
  const suntekSettings = useSuntekSettings();
  const [useReminder, setUseReminder] = useState<boolean>(false);
  useEffect(() => {
    if (memo && memo.id <= 0 && !memo.title){
      setMemo({ title: "General" });
    } 
    setUseReminder(memo.addAsTaskReminder);
    setTabIndex(memo.addAsTaskReminder ? 1 : 0);
  }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  const fontColorItem: Array<any> = memoTitle.map((x: any)=>({
    title: x, 
    color: x === "Task Reminder" ? 'red': 'black'
  }))

  function onChange(change: Partial<Memo>) {
    // setMemo({
    //   ...memo,
    //   ...change,
    // });
    setMemo(change);
  }

  async function odFileDrop(acceptedFiles: any[]) {
    const oriFiles = [...files];
    let duplicateFileName = '';

    for (let i = 0; i < oriFiles.length; i++) {
      for (let j = 0; j < acceptedFiles.length; j++) {
        if (oriFiles[i].file.name === acceptedFiles[j].name
          && oriFiles[i].file.size === acceptedFiles[j].size
          && oriFiles[i].file.lastModifiedDate.toString() === acceptedFiles[j].lastModifiedDate.toString()) {
          duplicateFileName = appendLine(duplicateFileName, acceptedFiles[j].name);
          //acceptedFiles = acceptedFiles.filter(x => (x.name !== acceptedFiles[j].name));
          acceptedFiles.splice(j,1);
          break;
        }
      }
    }

    for (let i = 0; i < acceptedFiles.length; i++) {
      if(acceptedFiles[i].size > 0 && acceptedFiles[i].size > (suntekSettings.accounting?.memoAttachedFileMaxSize??5000)*1000000){
        await showGlobalOkDialog(<p>{acceptedFiles[i].name} is larger than {suntekSettings.accounting?.memoAttachedFileMaxSize}MB</p>);
      }else if(acceptedFiles[i].size > 0){
        const newFile: AttachFile = new AttachFile({ logId: 0, logFileId: 0, file: acceptedFiles[i] });
        oriFiles.push(newFile);
      }else{
        await showGlobalOkDialog(<p>{acceptedFiles[i].name} is a Null File, Please Check it again!</p>);
      }
    }

    setFiles(oriFiles);

    if (!_.isEmpty(duplicateFileName))
      await showGlobalOkDialog(<p>Duplicate file is not attached<br />
        {duplicateFileName}
      </p>);
  }

  function deleteFile(e:any, i:number) {
    const newFiles = [...files];
    newFiles.splice(i, 1);

    setFiles(newFiles);

    e.preventDefault();
    e.stopPropagation();
  }

  async function openFile(e:any, i:number)
  {
    e.preventDefault();
    e.stopPropagation();

    const logFileId = files[i].logFileId;
    const logFileName = files[i].file.name;
    const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';

    openLogFile(logFileId, logFileName, userToken);
  }

  function renderDetails() {
    if (tabIndex === 0) {
      return <div {...getRootProps()}>
        <MemoDropzoneContainer>
          <div id='memo-log-accepted-files' className="accepted-files">
            {files.map((f, i) =>
              <div key={i} className="accepted-file">
                &nbsp;
                <button id={"AttachDelete" + i} className="ifms-black-inverse-button" onClick={e => deleteFile(e, i)} style={{ color: 'Red', padding: 0 }}>
                  <FontAwesomeIcon style={{ fontSize: '15px' }} icon={faTimes} data-tooltip="Open" />
                </button>
                &nbsp;
                {f.logId > 0
                  ?
                  <button id={"AttachOpen" + i} className="ifms-black-inverse-button" onClick={e => openFile(e, i)} style={{ padding: 0, paddingBottom: '2px' }}>
                    <img id={"AttachOpen" + i + "-img"} src={getFileIcon(f.file.name)} style={{ width: '17px', height: '17px' }} alt="" />
                  </button>
                  :
                  ''
                }
                &nbsp;
                {f.file.name}
              </div>
            )}
          </div>
          <input id='memo-log-dropFile' {...getInputProps()} />
          <h3>Drop files here (or click)</h3>
          <p className="upload-icon"><FontAwesomeIcon icon={faUpload} /></p>
        </MemoDropzoneContainer>
      </div>;
    }
    if (tabIndex === 1) {
      memo.operator = ((memo.operator === '' ? (appContext.user ? appContext.user.id ?? '' : '') : memo.operator));
      memo.remind = ((memo.remind === null||memo.remind === '') ? now() : memo.remind);
      memo.due = ((memo.due === null||memo.due === '') ? now() : memo.due);
      return <div style={{ height: '130px', paddingTop: '15px', paddingLeft: '30px' }}>
        <InlineInputControlRow mode="medium" label="Assign To">
          <LeftRightSplit
            leftSize="100px"
            rightSize="150px"
            left={
              <UsersDropDown
                value={memo.operator}                
                onChange={operator => {setMemo({operator : operator ?? ''})}}
              />
            }
            right={
              <div style={{ marginLeft: '20px' }}>
                <InlineInputControlRow mode="w40" label="Creator">
                  <TextBox
                    disabled={true}
                    value={memo.creator}
                  />
                </InlineInputControlRow>
              </div>
            }
          />
        </InlineInputControlRow>
        <InlineInputControlRow mode="medium" label="Reminder Date & Time">
          <div style={{ width: '130px' }}>
            <DateTime dateId="memo-remind" value={memo.remind} hideIcon={false}
              onChange={remind => {setMemo({remind : remind})}}
            /></div>
        </InlineInputControlRow>
        <InlineInputControlRow mode="medium" label="Due Date & Time">
          <div style={{ width: '130px' }}>
            <DateTime dateId="memo-due" value={memo.due} hideIcon={false}
              onChange={due => {setMemo({due: due})}}
            /></div>  </InlineInputControlRow>
        <InlineInputControlRow mode="medium" label="Status">
          <div style={{ display: 'flex' }}>
            <div style={{ width: '100px' }}>
              <RadioButton group="status" reverse label="Open"
                checked={memo.reminderStatus === 1}
                onChecked={(e) => { setMemo({reminderStatus : 1})}} /></div>
            <RadioButton group="status" reverse label="Done"
              checked={memo.reminderStatus === 0}
              onChecked={(e) => {setMemo({reminderStatus : 0}) }} /></div>
        </InlineInputControlRow>
      </div>;
    }

    return null;
  }
  const { getRootProps, getInputProps } = useDropzone({ onDrop: odFileDrop })

  return (
    <div>
      <div>Subject</div>
      <FilterableSelect2
          name='memo-log-subject'
          getId={(x, i) => `${i}-${x}`}
          getLabel={x => x}
          onSelect={title => {onChange({ title });
          if(title === "Task Reminder") {
            onChange({addAsTaskReminder: true});
            setUseReminder(true);
            setTabIndex(1);
          }
        }}
        onTextChange={title => onChange({ title })}
        items={memoTitle}
        initialValue={memo?.title ?? ""}
        maxLength={50}
        fontColorItem = {fontColorItem}
      />
      <div style={{ height: '10px' }}>&nbsp;</div>

      <div>Memo</div>
      <MultilineTextBox name='memo-log-memo' value={memo?.description ?? ''} onChange={
        e => {onChange({ description: e.target.value ?? '' })}} style={{ height: '300px' }} />

      <div style={{ height: '30px', display: 'flex', paddingTop: '7px' }}>
        <CheckBox label='Public' value={memo.isPublic} onChange={(e) => {setMemo({isPublic : e, memoType: e ? 'C' : ''})}} />
        <div style={{ width: '330px' }}></div>
        <CheckBox label='Task Reminder' value={memo.addAsTaskReminder} onChange={(e) => {setMemo({addAsTaskReminder : e}); setUseReminder(e) ; setTabIndex(e === true ? 1 : 0);}} />
      </div>
      <div className="" style={{ borderBottom: '2px solid #0F79FF', padding: '0px 20px', margin: '0 0 10px 0' }}>
        {renderTitleButton(<span>Attached File(s)</span>, tabIndex === 0, () => setTabIndex(0), appContext.useDarkMode)}
        {useReminder && renderTitleButton(<span>Task Reminder</span>, tabIndex === 1, () => setTabIndex(1), appContext.useDarkMode)}
      </div>
      {renderDetails()}
    </div>
  );
}


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * InfoAreaDrawer/Memo component
 */
function MemoView({
  data,
  onSave,
  onDelete,
  onPrint,
  memoTitle,
  logData,
  hideLogHistory,
  hideMemoList,
  jobName, jobId,
  files, 
  setFiles, 
  startFiles, 
  selectedMemoListIndex,
  setSelectedMemoListIndex,
  editMemo,
  setEditMemo,
  removeEditMemo
}:{
  data:Array<MemoPanelItem>,
  onSave: any,
  onDelete: any,
  onPrint: any,
  memoTitle:Array<any>,
  logData: Array<any>,
  hideLogHistory: boolean,
  hideMemoList: boolean,
  jobName: string, jobId: number,
  files: Array<any>, 
  setFiles: (change: Partial<Array<any>>) => void, 
  startFiles: MutableRefObject<Array<any> | null>,
  selectedMemoListIndex: number,
  setSelectedMemoListIndex:any,
  editMemo:any,
  setEditMemo:any,
  removeEditMemo:any,

}) {
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [selectedIndex, setSelectedIndex] = useState(selectedMemoListIndex);
  const { selectTableRow } = useTableRowSelection('ifms-app-bottom', `info-area-memo-table${hideLogHistory ? '-offlog' : '-onlog'}`, /*onDoubleClick*/null, onClick);
  const { getRootProps } = useDropzone({ onDrop: attachFileDrop, noKeyboard: true })
  const memoAndUpdateTableWidth = hideLogHistory ? '890px' : '560px';
  const logHistoryTableWidth = '600px';
  const memoDetailTextWidth = hideLogHistory ? '870px' : '560px';
  //const listSec = appContext.securityGrants?.find(x=>x.securityTaskCode == FmsSecTask.ToolMemo);
  // const [editByDoubleClick, setEditByDoubleClick] = useState(-1); // not used

  // useEffect(() => {
  //   // selectDefault();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // useEffect(() => {
  //   if (editByDoubleClick >= 0) {
  //     prepareMemoForEdit(editByDoubleClick);
  //     setEditByDoubleClick(-1);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [editByDoubleClick]);

  useEffect(() => {
    selectDefault();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  function selectDefault() {
    if (data && data.length > 0) {
    //Task Reminder List에서 이동했을때 해당 Memo Row를 클릭하기 위함
    if(appContext.myMemoId !== 0){ 
      //기존에 열려있던 Memo Detail이 있다면 창을 닫음
      const memoDetailCancelButton = document.getElementsByName('memo-log-cancel-button')[0];
      if(memoDetailCancelButton){
        memoDetailCancelButton.click();
      } 
      let index = 0;
      index = data.findIndex((x:any) => x.id === appContext.myMemoId);
      if(index >= 0) {
        selectTableRow(index);
        setSelectedIndex(index);
        setSelectedMemoListIndex(index);
      }else{
        selectTableRow(0);
        setSelectedIndex(0);
        setSelectedMemoListIndex(0);
      }
    }else{
      selectTableRow(0);
      setSelectedIndex(0);
      setSelectedMemoListIndex(0);
    }
  }
}
  // function onDoubleClick(index:number) {
  //   setSelectedIndex(index);
  //   setEditByDoubleClick(index);
  // }

  function onClick(index:number) {
    setSelectedIndex(index);
    setSelectedMemoListIndex(index);
  }

  function onMemoPopupClose(){
    appContext.setMyMemoTaskReminder(false);
    appContext.setMyMemoId(0);
    removeEditMemo();
  }

  function prepareMemoForEdit(index:number) {
    //<pt211223: parameter must be changed to Memo from current EditMemo>
    // setEditMemo({
    //   // @ts-ignore:next-line
    //   id: index >= 0 ? data[index].id : 0,
    //   title: index >= 0 ? data[index].title : '',
    //   description: index >= 0 ? data[index].contents : '',
    // });
    setMemoDetail(index, false);
  }

  async function setMemoDetail(index:number, isView: boolean){
    // selectedIndex --> index

    if(index >= 0 && index < data.length && _.isEmpty(editMemo)){
       const apiResult: ApiResult<Memo> = await appContext.api.getJobDetail(JobNames.Memo, { id: data[index].id});
       if (!apiResult || !apiResult.success) {
         await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
         return null;
       } else {
         const obj = { ...apiResult.result, jobId: jobId, jobName: jobName, edit: true, view: isView, editIndex: selectedIndex};
         const tEntity = new Memo(obj);
         setEditMemo(tEntity);
         tEntity.trackable = true;
          // LogDetails --> files
         const newfiles:Array<any> = [];
         tEntity.logFileDetails.map((logFile, index) => {
           const file = new AttachFile({
             logId: logFile.id,
             logFileId: logFile.logFileId,
             file: new File([], logFile.oFileName),
           });
             
           newfiles.push(file);
           return logFile;
         });
          setFiles(newfiles);
         const starts:Array<any> = [...newfiles]
         startFiles.current = starts;
       }
    } else {
      const tEntity2 = new Memo();
      tEntity2.tbName = getTbNameByJobName(jobName);
      tEntity2.jobName = jobName;
      tEntity2.jobId = jobId;
      setEditMemo(tEntity2);
      tEntity2.trackable = true;

      const files:Array<any> = [];
      setFiles(files);
      const starts:Array<any> = [...files]
      startFiles.current = starts;
    }
  }

  async function saveMemo() {
    //const newMemo = ({...editMemo});
    //setEditMemo(null);
    const result = await onSave(editMemo)
    if (result) {
      removeEditMemo();
      await showGlobalOkDialog(<p>{constants.SAVE_SUCCESS_DEFAULT_MSG}</p>);
    }
  }

  // function deleteMemo() {
  //   const noSelection = selectedIndex < 0 || selectedIndex >= data.length;
  //   if (noSelection) {
  //     return;
  //   }

  //   onDelete(data[selectedIndex].id);
  // }
  
  function deleteMemoByIndex(index:number) {
    onDelete(data[index].id);
  }

  function printMemo(index:number) {
    onPrint(data[index].id);
  }

  function MemoAttachRenderer({data, row}:any) {
    let attaches:Array<any> = data[row.index].attachments;

    function openFile(fileinfo:string)
    {
      const file = fileinfo.split('|');
      if (file && file.length === 3) {
        const logFileId = +file[0];
        const logFileName = file[1];
        const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';
    
        openLogFile(logFileId, logFileName, userToken);
      }
    }
  
    return (
      <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
        {attaches.map((f, i) => 
          <DarkInverseButton id={`memo-log-attachment-${f && f.split('|').length === 3 ? f.split('|')[1] : ''}-button`} key={`memo-log-attachment-${i}-button`}
          size="regular" onClick={() => openFile(f)} style={{ paddingLeft: '0px', paddingRight: '2px', paddingTop: '2px'}}>
            <span data-tooltip={f && f.split('|').length === 3 ? f.split('|')[1] : ''} >
            <img id={`memo-log-attachment-${f && f.split('|').length === 3 ? f.split('|')[1] : ''}-img`}src={getFileIcon(f)} style={{width: '16px', height: '16px'}} alt= "" />
            </span>
          </DarkInverseButton>
        )}
      </div>
    );
  }

  function LogTypeRenderer({ data, row }: any) {
    let memoType: string = data[row.index].type;
    let returnLabel = '';
    let imgSrc = '';
    async function openFile() {
      const item = data[row.index];
      if (item.logFileId <= 0) return;

      const logFileId = item.logFileId;
      const logFileName = item.oFileName;
      const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';

      await openLogFile(logFileId, logFileName, userToken);
    }

    async function openViewer() {
      let docType = DocumentType.Unknown;
      switch (data[row.index].type) {
        case "F":
          docType = DocumentType.LogFax;
          break;
        case "P":
          docType = DocumentType.LogPrint;
          break;
        case "E":
          docType = DocumentType.LogEmail;
          break;
      }

      const item = data[row.index];
      if (item.logFileId <= 0) return;
      
      let left = (document.body.offsetWidth / 2) - (980 / 2);
      left += window.screenLeft;

      window.open(`${config.serverUrl}report/logViewer?jwt=${appContext.api.getAuthKey()}&logFileId=${item.logFileId}&docType=${docType}`,
        '_blank',
        `width=980, height=${window.screen.availHeight},left=${left}, top=0, scrollbars=yes` 
      );
    }

    switch (memoType) {
      case "F":
        returnLabel = "Fax"
        imgSrc = FaxIcon;
        break;
      case "E":
        returnLabel = "Email"
        imgSrc = EmailIcon;
        break;
      case "P":
        returnLabel = "Print"
        imgSrc = PrintIcon;
        break;
      case "M":
        returnLabel = "Outlook"
        imgSrc = OutLookIcon;
        break;
      case "D":
        returnLabel = "Upload"
        imgSrc = UploadIcon;
        break;
      case "R":
        returnLabel = "Shared_R"
        imgSrc = SharedIcon;
        break;
      case "S":
        returnLabel = "Shared_S"
        imgSrc = SharedIcon;
        break;
      case "X":
        returnLabel = "Unshared"
        imgSrc = UnSharedIcon;
        break;
      case "A":
        returnLabel = "Shared_PDF"
        imgSrc = SharedPDFICon;
        break;
    }

    return (
      <div className="ifms-table-align-left">
        <span style={{ width: '30px', display: 'inline-block' }}><img style={{ width: '15px' }} src={imgSrc} alt='' ></img></span>
        <span
          onClick={async () => {
            switch (data[row.index].type) {
              case "F":
              case "P":
              case "E":
                await openViewer();
                break;
              default:
                await openFile();
                break;
            }
          }}
          style={{ width: '60px', display: 'inline-block', cursor: 'pointer', color: 'blue', fontWeight: 'bold' }} >
          {returnLabel}</span>
        {data[row.index].oFileName}
      </div >
    );
  }

  const tableOptions:ApplicableTableSettings = {
    tableName: `info-area-memo-table${hideLogHistory ? '-offlog' : '-onlog'}`,
    ...infoAreaMemoTable,
    width: memoAndUpdateTableWidth,
    height: `${document.getElementsByClassName('ia-drawer-content-list')[0]?.clientHeight - 6}px`,
    data: data.map(d => ({...d, prepareMemoForEdit, deleteMemoByIndex, printMemo})),
    
    selectable: true,
    cellRangeSelect: false,
    rowRenderers: [
      { accessor: 'updateAt', Cell: DateTimeRenderer },
      { accessor: 'jobType', Cell: TextRenderer },
      { accessor: 'title', Cell: TextAlignLeftRenderer },
      { accessor: 'updateBy', Cell: TextAlignLeftRenderer },
      { accessor: 'attachment', Cell: MemoAttachRenderer },
    ],
  };

  const showDetails = !isNaN(selectedIndex) && selectedIndex >= 0 && selectedIndex < data.length
    ? data[selectedIndex].details
    : '';
  const showTitle = !isNaN(selectedIndex) && selectedIndex >= 0 && selectedIndex < data.length
    ? data[selectedIndex].title
    : '';

  const logHistoryTableOptions:ApplicableTableSettings = {
    tableName: 'info-area-loghistory-table',
    ...infoAreaLogHistoryTable,
    data: logData,
    width: logHistoryTableWidth,
    height: `${document.getElementsByClassName('ia-drawer-content-list')[0]?.clientHeight - 6}px`,
    
    rowRenderers: [
      { accessor: 'postDate', Cell: DateTimeIncludeSecRenderer },
      { accessor: 'type', Cell: LogTypeRenderer },
      { accessor: 'senderId', Cell: TextAlignLeftRenderer },
      //{ accessor: 'title', Cell: LogTitleRenderer },
    ],
  };

  // const canBeAdd = listSec?.grantAdd;
  // const canBeEdit = !(selectedIndex < 0 || data.length <= 0 || data[selectedIndex]?.title === "History Update") && listSec?.grantEdit
  //     && !appContext.getControlDisableStatus(JobNames.Main, 'btnMemoEdit', FormType.ModeEdit);
  // const canBeDeleted =  !(selectedIndex < 0 || data.length <= 0 || data[selectedIndex]?.title === "History Update") && listSec?.grantDel
  //     && !appContext.getControlDisableStatus(JobNames.Main, 'btnMemoDelete', FormType.ModeEdit);

  async function attachFileDrop(acceptedFiles: any[]) {
    setMemoDetailWithFile(acceptedFiles);        
  }

  interface MailInfo {
    subject?: string,
    body?: string,
    header?: string,
    senderName?: string,
    senderEmail?: string,
    attachments?: any [],
    error?: string,
  };
  interface AttachInfo {
    content: Uint8Array,
    fileName: string,
  };

  async function setMemoInfo(subject: string, body: string, attachFiles: any[]){
    const tEntity2 = new Memo();
    tEntity2.tbName = getTbNameByJobName(jobName);
    tEntity2.jobName = jobName;
    tEntity2.jobId = jobId;
    tEntity2.title = subject?.slice(0, 50);
    tEntity2.description = body;
    setEditMemo(tEntity2);
    tEntity2.trackable = true;

    setFiles(attachFiles);

    const starts:Array<any> = [];
    startFiles.current = starts;
}

  async function setMemoDetailWithFile(dropFiles: any[]){
    let cntMail = 0;
    let mailFile: any;
    let subject = "", body = "";
    const files:Array<any> = [];

    dropFiles.map((aFile, index) => {
      if (aFile.size > 0) {
        if (aFile.name.indexOf('.msg') >= 0) {
          mailFile = aFile;
          cntMail++;
        }
        else {
          const newFile: AttachFile = new AttachFile({ logId: 0, logFileId: 0, file: aFile });
          files.push(newFile);
        }
      }
      return aFile;
    });

    if (cntMail > 1) {
      await showGlobalOkDialog(<p>There is not one mail file, please select only one mail data.</p>);
      return;
    }
    else if (cntMail === 1 && !!mailFile) {
      // msg.reader 이용해서 Outlook 메일을 읽어온다.
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const buffer = e.target?.result;
        const msgReader = new MSGReader(buffer);
        const fileData: MailInfo = msgReader.getFileData() as MailInfo;
        if (!fileData.error) {
          subject = fileData.subject??'';
          body = fileData.body??'';

          fileData.attachments?.map((attachment, index) => {
            const attactfile = msgReader.getAttachment(index) as AttachInfo;
            const file = new File([attactfile.content], attactfile.fileName );
            const newFile: AttachFile = new AttachFile({ logId: 0, logFileId: 0, file: file });
            files.push(newFile);
            return attachment;
          });

          setMemoInfo(subject, body, files);
        } else {
          showGlobalOkDialog(<p>Failed to parse mail data.</p>);
        }
      };
      fileReader.readAsArrayBuffer(mailFile);
    }
    else {
      await setMemoInfo(subject, body, files);
    }
  }

  return (
    <div className="ia-drawer-content">
      {/* <div className="ia-commands">
        {!hideMemoList &&
          <div>
            <SecondaryButton size="regular" onClick={() => prepareMemoForEdit(-1)} disabled={!canBeAdd} >
              <FontAwesomeIcon icon={faPlus} />&nbsp;New
            </SecondaryButton>&nbsp;
            <SecondaryButton size="regular" disabled={!canBeEdit} onClick={() => prepareMemoForEdit(selectedIndex)}>
              Edit
            </SecondaryButton>&nbsp;
            <SecondaryButton size="regular" disabled={!canBeDeleted} onClick={() => deleteMemoByIndex(selectedIndex)}>
              Delete
            </SecondaryButton>&nbsp;
            <SecondaryButton size="regular" disabled={selectedIndex < 0 || data.length <= 0} onClick={() => printMemo(selectedIndex)}>
              Print
            </SecondaryButton>
          </div>
        }
      </div> */}

      <div className='ia-drawer-content-list'>
        {!hideMemoList &&
          <>
            <div {...getRootProps()} style={{ width: memoAndUpdateTableWidth, flexShrink: 0 }}>
              <Label label="Memo / Task List" bold />
              <SmartTable {...tableOptions} />
            </div>
            <div style={{ minWidth: '300px', width: '100%', marginLeft: '40px', marginRight: hideLogHistory ? '0px' : '40px' }}>
              <Label label={' '} bold />
              <TextBox disabled textId='info-area-memo-title' style={{ border: `1px solid gray`, backgroundColor: 'white', padding: '5px' }} value={showTitle} />
              <MultilineTextBox disabled textId='info-area-memo-content' style={{ border: `1px solid gray`, backgroundColor: 'white', height: "calc(100% - 50px)", padding: '5px', overflowY: 'scroll' }} value={showDetails} />
            </div>
          </>
        }
        {!hideLogHistory &&
          <>
            <div id='ia-drawer-logHistory' style={{ width: logHistoryTableWidth, flexShrink: 0 }}>
              <Label label="Document List" bold />
              <SmartTable {...logHistoryTableOptions} />
            </div>
          </>
        }
      </div>
      <IfmsModal
        memoCloseOnEsc
        isOpen={!!editMemo}
        isBlueHeader
        title="Memo"
        width='530px'
        draggable
        onCancel={onMemoPopupClose}
      >
        <div className='report-popup'>
          <div>
            {!!editMemo &&
              <MemoDetails memo={editMemo} setMemo={setEditMemo} memoTitle={memoTitle} files={files} setFiles={setFiles} />
            }
          </div>
          <div className="clearfix"></div>
          <div className="report-footer" >
            <SecondaryButton name='memo-log-save-button' size="regular" focusable={true} onClick={saveMemo}>
              SAVE
            </SecondaryButton>&nbsp;&nbsp;
            <SecondaryButton name='memo-log-cancel-button' size="regular" focusable={true} onClick={onMemoPopupClose}>
              CANCEL
            </SecondaryButton>
          </div>
        </div>
      </IfmsModal>
    </div>
  );
}

function usePrevious(value:any):any|null {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * InfoAreaDrawer React component
 * 12/23/2021 ptkim     entityId, entityName => jobId, jobName
 */
function InfoAreaDrawer({
  jobName,
  jobId,
  customTabs = [],
  showContent,
  onClose,
  hideLogHistory = false,
  hideMemoList = false,
  com1Id = 0,
  beforeMemoNewOpen = undefined,
  isNewMemo = undefined,
}: {
  jobName:string, 
  jobId:number,
  customTabs?: Array<any>,
  showContent: string,
  onClose: VoidFunction,
  hideLogHistory?: boolean,
  hideMemoList?: boolean,
  com1Id?: number,
  beforeMemoNewOpen?: () => Promise<boolean>,
  isNewMemo?: MutableRefObject<boolean>,
}) {
  const [editMemo, setEditMemo, removeEditMemo, ] = useTypedFastStorage<Memo>(`ifms-memo-editable`, null);

  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const [memoTitle, setMemoTitle] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  const [memo, setMemo] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedMemoListIndex, setSelectedMemoListIndex] = useState(0);
  const [extraTabContent, setExtraTabContent] = useState<any>(null);
  const prevContent = usePrevious(showContent);
  const systemSettings = useSystemSettings();
  
  const startFiles = useRef<Array<any>>([]);
  const [files, setFiles] = useState<Array<any>>([]);
  const {viewReport} = useReportViewer();
  const listSec = findSecurityTask(appContext, FmsSecTask.ToolMemo);

  const history = useHistory();
  const currentUrl = `${history.location.pathname}${history.location.search}`;
  const isListView = currentUrl.includes('common/joblistview');

  async function loadMemoTitle() {
    const search = {
      orderBy: 'code',
      orderByAscending: true,
      pageSize: systemSettings.defaultPageSize
    } as Search;

    const apiResult = await appContext.api.getListItems(JobNames.MemoTitle, 
      'CodeMemoTitleListItem',
      CodeMemoTitleListItem.calculateSearchParameters(search),
      1,
      search.pageSize
      );
    if (apiResult?.entities && apiResult?.totalCount > 0) {
      const nonEmptyTitles = apiResult.entities.filter((x:any) => !!x.description && !x.inactive).map((x:any) => x.description);
      if ( nonEmptyTitles.length > 0) {
        nonEmptyTitles.unshift("Task Reminder");
        nonEmptyTitles.unshift("General");
        setMemoTitle(nonEmptyTitles);
      }
    }else {
      setMemoTitle(["General", "Task Reminder"]);
    }
  }

  async function loadData() {
    loadMemoTitle();

    if(!jobName || !jobId) {
      return;
    }

    // if (!!memo && memo.jobId === jobId && memo.jobName === jobName) {
    //   return;
    // }

    setLoading(true);
    const apiResult = await appContext.api.getJobListPanelItems(jobName, jobId, com1Id);
    setMemo(apiResult);
    setLoading(false);
  }

  async function saveMemo(memo:any) : Promise<any>{
    if (!jobId || !jobName) {
      return false;
    }

    if(isEmpty(memo.title)){
      await showGlobalOkDialog(`Please input the Memo Subject`);
      return false;
    }

    if (memo.addAsTaskReminder) {
      if (compareIso(memo.remind, memo.due) > 0) {
        await showGlobalOkDialog(`Please Set the Due Date Later than Remind Date&Time!`);
        return false;
      }
    }

    channel.publish('ajax.loadingstart', {});
    
    setLoading(true);

    const userId = appContext.user ? appContext.user.id ?? '' : '';
    const mainChange: Partial<Memo> = {};
    if (memo.id <= 0){
      mainChange.createdBy = userId;
      mainChange.createdAt = now();
    } 
    mainChange.modifiedBy = userId; 
    mainChange.modifiedAt = now(); //dirty 발생
    
    if (!_.isEmpty(mainChange)) {
      setEditMemo(mainChange);
    }


    const sqlInfoList = getSQLInfoList(memo as TrackableEntity);

    // Check Attach Files
    let i: number, k: number;
    const deletedFiles:Array<any> = [];

    if (startFiles?.current) {
      for (i = 0; i < startFiles.current.length; i++) {
        for (k = 0; k < files.length; k++) {
          if (startFiles.current[i].logId === files[k].logId && startFiles.current[i].file.name === files[k].file.name) break;          
        }
        if (k < files.length) files.splice(k, 1);
        else deletedFiles.push(startFiles.current[i]);
      }
    }
    const addedFiles: Array<any> = [...files];

    deletedFiles.map((delFile, index) => {
      sqlInfoList.push(new SQLInfo({
        tableName: "T_NLOGFILE",
        type: SQLType.Delete,
        where: `F_Idex = (select F_LogFileID from T_NLogMain where F_Idex=${delFile.logId ?? 0})`
      }));
      sqlInfoList.push(new SQLInfo({
        tableName: "T_NLOGMAIN",
        type: SQLType.Delete,
        key: new SQLField({ fieldName: "F_Idex", propertyName: "idex", value: delFile.logId ?? 0 }),
      }));
      return delFile;
    });

    const reminderSql: SQLInfo[] = [];
    if (checkPropDirty(memo, 'addAsTaskReminder')) {
      if (memo.addAsTaskReminder) {
        reminderSql.push(new SQLInfo({
          tableName: "T_AOTHERINFO",
          type: SQLType.Insert,
          fields: [
            new SQLField({ fieldName: "F_C1", propertyName: "C1", value: memo.operator }),
            new SQLField({ fieldName: "F_C2", propertyName: "C2", value: memo.operator }),
            new SQLField({ fieldName: "F_D1", propertyName: "D1", value: memo.remind }),
            new SQLField({ fieldName: "F_D2", propertyName: "D2", value: memo.due }),
            new SQLField({ fieldName: "F_N1", propertyName: "N1", value: memo.addAsTaskReminder }),
            new SQLField({ fieldName: "F_N2", propertyName: "N2", value: memo.reminderStatus }),
          ],
          whereFields: [
            new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
            new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
            new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
          ]
        }));
      } else {
        reminderSql.push(new SQLInfo({
          tableName: "T_AOTHERINFO",
          type: SQLType.Delete,
          whereFields: [
            new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
            new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
            new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
          ]
        }));
      }
    } else if (memo.addAsTaskReminder) {
      reminderSql.push(new SQLInfo({
        tableName: "T_AOTHERINFO",
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "F_C1", propertyName: "C1", value: memo.operator }),
          new SQLField({ fieldName: "F_C2", propertyName: "C2", value: memo.creator }),
          new SQLField({ fieldName: "F_D1", propertyName: "D1", value: memo.remind }),
          new SQLField({ fieldName: "F_D2", propertyName: "D2", value: memo.due }),
          new SQLField({ fieldName: "F_N1", propertyName: "N1", value: memo.addAsTaskReminder }),
          new SQLField({ fieldName: "F_N2", propertyName: "N2", value: memo.reminderStatus }),
        ],
        whereFields: [
          new SQLField({ fieldName: 'f_tbname', propertyName: 'TbName', value: 'T_MEMO' }),
          new SQLField({ fieldName: 'f_tbid', propertyName: 'TbId', value: memo.id }),
          new SQLField({ fieldName: 'f_type', propertyName: 'Type', value: 0 })
        ]
      }));
    }

    sqlInfoList.push(...reminderSql);
    const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.Memo, sqlInfoList, {});

    const insertResult = apiResult?.result?.insertList.find(x => x.model === 'Memo');
    const savedId = insertResult?.newId ?? memo.id;

    // setMemo({id: savedId});

    if (apiResult && apiResult.success) {
      // Added Files
      const formData = new FormData();
      for (let i = 0; i < addedFiles.length; i++) {
        formData.append("file", addedFiles[i].file);
      }
      formData.append("memoId", '' + savedId);
      formData.append("jobName", '' + jobName);
      formData.append("memoType", 'D');
      if (memo.addAsTaskReminder) {
        //Task Reminder가 활성화되어있고, Reminder 관련 Dirty 발생시
        if (checkPropDirty(memo, 'operator')|| checkPropDirty(memo,'creator')||checkPropDirty(memo,'remind') ||checkPropDirty(memo,'due') || checkPropDirty(memo,'reminderStatus')) {
          appContext.setUseCheckReminder(!appContext.useCheckReminder);
        }
      }

      const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.upload(formData);
      if (apiResult2 && apiResult2.success) {
      }

      //memo 저장 후 subject title에 따라 Manifest의 데이터 갱신되도록 추가
      if(jobName === JobNames.BTOrder){
        let sqlInfos: SQLInfo[] = [];
        let update = false;
        console.log(memo.title);
          if(memo.title.toUpperCase().includes("COMMERCIAL INVOICE") && memo.title.toUpperCase().includes("PACKING LIST")){
          update = true;
          sqlInfos.push(new SQLInfo({
            tableName: "T_BTORDER",
            type: SQLType.Update,
            fields:[
              new SQLField({fieldName: "F_Ci", propertyName:'ci', value: '1'}),
              new SQLField({fieldName: "F_Pl", propertyName:'pl', value: '1'})
            ],
            whereFields:[
              new SQLField({fieldName:"F_ID", propertyName:'id', value:jobId})
            ]
          })); 
        
        } else if(memo.title.toUpperCase().includes("COMMERCIAL INVOICE")){
          update = true;
          sqlInfos.push(new SQLInfo({
            tableName: "T_BTORDER",
            type: SQLType.Update,
            fields:[
              new SQLField({fieldName: "F_Ci", propertyName:'ci', value: '1'}),
            ],
            whereFields:[
              new SQLField({fieldName:"F_ID", propertyName:'id', value:jobId})
            ]
    })); 
        } else if(memo.title.toUpperCase().includes("PACKING LIST")){
          update = true;
            sqlInfos.push(new SQLInfo({
                    tableName: "T_BTORDER",
                    type: SQLType.Update,
                    fields:[
                      new SQLField({fieldName: "F_Pl", propertyName:'pl', value: '1'})
                    ],
                    whereFields:[
                      new SQLField({fieldName:"F_ID", propertyName:'id', value:jobId})
                    ]
          })); 
        }
        if(update){
          const apiResult3: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.BTOrder,
            sqlInfos,
            {});
        }
      } 


    } else {
      await showGlobalOkDialog(`Failed to save : ${apiResult?.message}`);
      return false;
    }

    setLoading(false);
    appContext.setMyMemoTaskReminder(false);
    appContext.setMyMemoId(0);
    loadData();

    channel.publish('ajax.loadingend', {});
    return true;
  }

  async function deleteMemo(id:string|number) {
    if (!jobId || !jobName) {
      return;
    }

    const confirmDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (!confirmDelete) {
      return;
    }

    setLoading(true);

    const apiResult = await appContext.api.deleteJobDetail(JobNames.Memo, { id });
    if (apiResult && !apiResult.success) {
      const message = apiResult?.message ?? 'Cannot delete!';
      showGlobalOkDialog(message);
    }

    setLoading(false);
    loadData();
  }

  async function printMemo(id:number) {
    if (!jobId || !jobName || id <= 0) {
      return;
    }

    const confirmPrint = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to print?</h3>
      </div>
    ,false, 0, true);

    if (!confirmPrint) {
      return;
    }
    const title = 'Memo Log';
    const args = new MemoArgs({
      formCaption: title,
      subject: title,
      tbId: jobId?.toString(),
      tbName: getTbNameByJobName(jobName),
    });
    viewReport(args, "", true); 
  }

  useEffect(() => {
    let memoTableEle = document.getElementById(`info-area-memo-table${hideLogHistory ? '-offlog' : '-onlog'}`);
    let logHistoryTableEle = document.getElementById('info-area-loghistory-table');
    if (memoTableEle)
      //51 = 20 + 22 + 3 + 6 (ia-drawer-content-title + info-area-title + memo-resizer + custom margin)
      memoTableEle.style.height = `${appContext.appInfoAreaDrawerHeight - 51 }px`;
    if (logHistoryTableEle)
      //51 = 20 + 22 + 3 + 6 (ia-drawer-content-title + info-area-title + memo-resizer + custom margin)
      logHistoryTableEle.style.height = `${appContext.appInfoAreaDrawerHeight - 51}px`;

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appContext.appInfoAreaDrawerHeight])

  useEffect(() => {
    if (!showContent || showContent === 'none' || jobId <= 0) {
      return;
    }
    setTimeout(() => {
      const table = document.querySelectorAll('[id*=tbl-list]')[0] as HTMLElement;
      if (!table && isListView) { //listview에서 더블클릭했을 때는 아래 코드를 수행할 필요 없음
        return;
      }
      loadData();
      if (selectedIndex > 0) {
        loadExtraTabContent(selectedIndex - 1);
      }
      setSecurityControl();
      if(jobId > 0 && isNewMemo && beforeMemoNewOpen){
        if(isNewMemo.current && !loading) {
          setMemoDetail(-1,false);
          isNewMemo.current = false;
        }
      }
    }, 500);

    return () => {
      setLoading(false);
      setMemoTitle([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId, jobName, showContent]);


  function setSecurityControl() {
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.Main] : null;
    if (!secCont) {
      secCont = [{ secCntr: FmsSecCntr.MemoEdit, contName: 'btnMemoEdit' },
      { secCntr: FmsSecCntr.MemoDelete, contName: 'btnMemoDelete' }];
      appContext.setSecurityControls(JobNames.Main, secCont);
    }
  }

  useEffect(() => {
    if (prevContent !== 'custom' && showContent === 'custom') {
      setSelectedIndex(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showContent]);

  useEffect(() => {
    if (selectedIndex > 0) {
      loadExtraTabContent(selectedIndex - 1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndex]);

  async function loadExtraTabContent(i:number) {
    setLoading(true);
    //<pt211223: change parameter>
    const extraContent = await extraTabs[i].contentLoader({ jobName, jobId, ...extraTabs[i].params});
    setExtraTabContent(extraContent);
    setLoading(false);
  }

  let renderedMemo;
  if (showContent === 'memo') {
    renderedMemo = <MemoView
      data={memo?.memo || []}
      onSave={saveMemo}
      onDelete={deleteMemo}
      onPrint={printMemo}
      memoTitle={memoTitle}
      logData={memo?.logHistory || []}
      hideLogHistory={hideLogHistory}
      jobName={jobName}
      jobId={jobId}
      files={files}
      setFiles={setFiles}
      startFiles={startFiles}
      hideMemoList={hideMemoList}
      selectedMemoListIndex={selectedMemoListIndex} 
      setSelectedMemoListIndex={setSelectedMemoListIndex} 
      editMemo={editMemo}
      setEditMemo={setEditMemo}
      removeEditMemo={removeEditMemo}
      />
  } else if (showContent === 'custom') {
    renderedMemo = extraTabContent;
  }

  const extraTabs = !!customTabs ? customTabs : [];


  const resizable = function (resizer: any) {
    const prevSibling = document.getElementById('ifms-info-area-drawer');
    let y = 0;
    let prevSiblingHeight = 0;
    let memoTableEle = document.getElementById(`info-area-memo-table${hideLogHistory ? '-offlog' : '-onlog'}`);
    let logHistoryTableEle = document.getElementById('info-area-loghistory-table');

    const mouseDownHandler = function (e: MouseEvent) {
      y = e.clientY;
      if (prevSibling) {
        const rect = prevSibling.getBoundingClientRect();
        prevSiblingHeight = rect.height;
      }

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };

    const mouseMoveHandler = function (e: MouseEvent) {
      const dy = e.clientY - y;

      if (prevSibling) {
        const tempHeight = prevSiblingHeight + (-dy);
        prevSibling.style.height = `${tempHeight < 100 ? 100 : tempHeight}px`;
        appContext.setAppInfoAreaDrawerHeight(prevSiblingHeight);

        const cursor = "row-resize";
        resizer.style.cursor = cursor;
        document.body.style.cursor = cursor;

        prevSibling.style.userSelect = "none";
        prevSibling.style.pointerEvents = "none";

        const drawerContentListHeight = document.getElementsByClassName('ia-drawer-content-list')[0]?.clientHeight;

        if (memoTableEle)
          memoTableEle.style.height = `${drawerContentListHeight - 6}px`;
        else
          memoTableEle = document.getElementById(`info-area-memo-table${hideLogHistory ? '-offlog' : '-onlog'}`);

        if (logHistoryTableEle)
          logHistoryTableEle.style.height = `${drawerContentListHeight - 6}px`;
        else
          logHistoryTableEle = document.getElementById('info-area-loghistory-table');
      }
    };

    const mouseUpHandler = function () {
      if (prevSibling) {
        resizer.style.removeProperty("cursor");
        document.body.style.removeProperty("cursor");
        appContext.setAppInfoAreaDrawerHeight(prevSibling.clientHeight);

        prevSibling.style.removeProperty("user-select");
        prevSibling.style.removeProperty("pointer-events");

        const table = document.querySelectorAll('[id*=tbl-list]')[0] as HTMLElement;
        if (table)
          doAdjustTableHeight(table);

        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      }
    };

    resizer.addEventListener("mousedown", mouseDownHandler);
  };

  // document.querySelectorAll(".memo-resizer").forEach(function (ele) {
  //   resizable(ele);
  // });

  const element = document.getElementById('memo-up-down-button');
  if(element) resizable(element);


  async function newMemoOpen(){
    if(jobId <= 0 && beforeMemoNewOpen){
      const saved = await beforeMemoNewOpen();
      if (!saved) {
        let errorMsg = `Cannot create memo because ${getOpNameByJobName(jobName)} was not saved.`;
        await showGlobalOkDialog(<p>{errorMsg}</p>)
        return false;
      }
    } else {
      setMemoDetail(-1,false);
    }
  }

  async function setMemoDetail(index:number, isView: boolean){
    if(index >= 0 && index < memo?.memo.length && _.isEmpty(editMemo)){
       const apiResult: ApiResult<Memo> = await appContext.api.getJobDetail(JobNames.Memo, { id: memo?.memo[index].id});
       if (!apiResult || !apiResult.success) {
         await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
         return null;
       } else {
         const obj = { ...apiResult.result, jobId: jobId, jobName: jobName, edit: true, view: isView, editIndex: selectedMemoListIndex};
         const tEntity = new Memo(obj);
         setEditMemo(tEntity);
         tEntity.trackable = true;
          // LogDetails --> files
         const newfiles:Array<any> = [];
         tEntity.logFileDetails.map((logFile, index) => {
           const file = new AttachFile({
             logId: logFile.id,
             logFileId: logFile.logFileId,
             file: new File([], logFile.oFileName),
           });
             
           newfiles.push(file);
           return logFile;
         });
         setFiles(newfiles);
         const starts:Array<any> = [...newfiles]
         startFiles.current = starts;
       }
    } else {
      const tEntity2 = new Memo();
      tEntity2.tbName = getTbNameByJobName(jobName);
      tEntity2.jobName = jobName;
      tEntity2.jobId = jobId;
      setEditMemo(tEntity2);
      tEntity2.trackable = true;

      const files:Array<any> = [];
      setFiles(files);
      const starts:Array<any> = [...files]
      startFiles.current = starts;
    }
  }

  function doAdjustTableHeight(table: HTMLElement) {
    if (!table) {
      return;
    }

    const tableScrollbarHeight = table.getBoundingClientRect().height - table.clientHeight;

    let titleBarHeight = 0;
    let infoAreaHeight = 0;

    const titleBars = document.getElementsByClassName(!appContext.useDarkMode ? 'ifms-screen-title-bar' : 'ifms-screen-title-bar-darkmode');
    if (titleBars && titleBars.length > 0) {
      var tbRect = titleBars[0].getBoundingClientRect();
      titleBarHeight = tbRect.bottom;
    }

    const infoArea = document.getElementById('ifms-info-area-drawer');
    if (infoArea && infoArea.dataset.open === 'true')
      infoAreaHeight = infoArea.clientHeight - tableScrollbarHeight; // In case info area is open don't make list appear above info area

    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    table.style.height = showContent !== 'none' ? `${vh - titleBarHeight - infoAreaHeight - 19}px` : `${vh - titleBarHeight - infoAreaHeight}px`;
  }

  useEffect(() => {
    if (appContext.appInfoAreaDrawerHeight === 0) appContext.setAppInfoAreaDrawerHeight(243);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const memoLen = memo?.memo?.length??0;
  const memoTitleIsUpdate = memoLen > 0 && memo?.memo?.length >= memoLen &&  memo?.memo[selectedMemoListIndex]?.title === "Update History";

  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = memo && !(selectedMemoListIndex < 0 || memoLen <= 0 || memoTitleIsUpdate) && listSec?.grantEdit
    && !appContext.getControlDisableStatus(JobNames.Main, 'btnMemoEdit', FormType.ModeEdit);
  const canBeDeleted = memo && !(selectedMemoListIndex < 0 || memoLen <= 0 || memoTitleIsUpdate) && listSec?.grantDel
    && !appContext.getControlDisableStatus(JobNames.Main, 'btnMemoDelete', FormType.ModeEdit);

  return (
    <Portal node={document && document.getElementById('ifms-app-bottom')}>
      <BottomDrawer open={!!showContent && showContent !== 'none'}>
        <div id="ifms-info-area-drawer" className="ia-drawer-wrapper" style={{ width: '100%', height:`${appContext.appInfoAreaDrawerHeight}px`}} data-open={!!showContent && showContent !== 'none' ? 'true' : 'false'}>
          {/* <div className="memo-resizer" data-direction="vertical"></div> */}
          <div className={`${!appContext.useDarkMode ? 'info-area-title' : 'info-area-title-darkmode'}`}>
            <div className="info-area-title-label">
              {showContent === 'memo' &&
                <>Memo / Task / Log</>
              }
              {showContent === 'custom' &&
                <>{extraTabs[selectedIndex - 1]?.headline || ''}</>
              }
            </div>
            {/* <CloseButton mode="light" size="extrasmall" onClick={onClose} /> */}
            <div>
              {!hideMemoList &&
                <>
                  <SecondaryButton name='memo-log-new-button' size="extrasmall" onClick={() => newMemoOpen() } disabled={!canBeAdd} >
                    <FontAwesomeIcon icon={faPlus} />&nbsp;New
                  </SecondaryButton>&nbsp;
                  <SecondaryButton id='memo-log-edit-button' name='memo-log-edit-button' size="extrasmall" disabled={!canBeEdit} onClick={() => setMemoDetail(selectedMemoListIndex, false)}>
                    Edit
                  </SecondaryButton>&nbsp;
                  <SecondaryButton name='memo-log-delete-button' size="extrasmall" disabled={!canBeDeleted} onClick={() => deleteMemo(memo?.memo[selectedMemoListIndex]?.id)}>
                    Delete
                  </SecondaryButton>&nbsp;
                  <SecondaryButton name='memo-log-print-button' size="extrasmall" disabled={selectedMemoListIndex < 0 || memo?.memo?.length <= 0} onClick={() => printMemo(memo?.memo[selectedMemoListIndex]?.id)}>
                    Print
                  </SecondaryButton>
                </>
              }
            </div>

            <div style={{ cursor: 'row-resize', marginLeft: '480px' }}>
              <img
                height='17px'
                id='memo-up-down-button'
                src={memoUpDownIcon}
                alt="Memo / Task / Log Up And Down"
                data-tooltip="Memo / Task / Log Up And Down"
                style={{ position: 'relative', right: '5px' }}
              />
            </div>

            <div id='memo-log-x-button' onClick={onClose} style={{ cursor: 'pointer', marginLeft: 'auto', marginRight: '15px', fontSize: '16px' }}>
              <FontAwesomeIcon icon={faTimes} />
            </div>
          </div>
          <div style={{clear: 'both'}}></div>
          <div style={{height: '2px', position: 'relative', bottom: '2px'}}>
            {loading &&
              <SkeletonTheme color="#4287f5" highlightColor="#b9d2fa">
                <Skeleton count={1} height={2} />
              </SkeletonTheme>
            }
          </div>
          <div id = 'ia-drawer-container' className={`ia-drawer-container background-${appContext.backgroundColor}`} >
            {renderedMemo}
          </div>
        </div>
      </BottomDrawer>
    </Portal>
  );
};

InfoAreaDrawer.defaultProps = {
  showContent: 'none',
  onClose: () => {},
  hideCustomHeadline: false,
};

InfoAreaDrawer.propTypes = {
  //entityId: 
  jobId:PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //entityName: 
  jobName: PropTypes.string.isRequired,
  customTabs: PropTypes.arrayOf(PropTypes.shape({
    headline: PropTypes.node.isRequired,
    contentLoader: PropTypes.oneOfType([
      PropTypes.shape({
        then: PropTypes.func.isRequired,
        catch: PropTypes.func.isRequired
      }),
      PropTypes.func]
    ).isRequired,
  })),
  showContent: PropTypes.oneOf(['custom', 'memo', 'none']).isRequired,
  onClose: PropTypes.func.isRequired,
  hideCustomHeadline: PropTypes.bool.isRequired,
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default React.memo(InfoAreaDrawer);
